import { useHeaderController } from './controller';
import { StyledText } from './styles';
import { HeaderViewProps } from './types';

export function Header({ error, success, isRequired }: HeaderViewProps) {
  const { color, text } = useHeaderController(error, success, isRequired);

  return <StyledText size={8} text={text} color={color} weight="Medium" />;
}
